/**
 * @description: 导购员工业绩明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="dym-report">
        <div class="dym-list">
            <el-form :inline="true" size="small" :model="dym_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="dym_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="dym_list_form.start_date"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="dym_list_form.end_date"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="dym_list_form.shop_id" filterable clearable placeholder="请选择门店" @change="dymShopChange">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="包厢区域">
                    <el-input v-model="dym_area_names" class="el-ellipsis" clearable placeholder="请选择包厢区域" :disabled="dym_area_disabled" @focus="dymAreaSelect" @clear="dymAreaDel"></el-input>
                </el-form-item>
                <el-form-item label="包厢号">
                    <el-select v-model="dym_list_form.room_id" filterable clearable placeholder="请选择包厢号" :disabled="dym_list_form.room_disabled">
                        <el-option v-for="item in room_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="操作人">
                    <el-select v-model="dym_list_form.admin_id" filterable clearable placeholder="请选择操作人">
                        <el-option v-for="item in admin_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="支付类型">
                    <el-input v-model="dym_pay_names" class="el-ellipsis" clearable placeholder="请选择支付类型" @focus="dymPaySelect" @clear="dymPayDel"></el-input>
                </el-form-item>
                <el-form-item label="商品类型">
                    <el-input v-model="dym_gtype_names" class="el-ellipsis" clearable placeholder="请选择商品类型" @focus="dymGtypeSelect" @clear="dymGtypeDel"></el-input>
                </el-form-item>
                <el-form-item label="商品名称">
                    <el-input v-model="dym_list_form.goods_name" placeholder="请输入商品名称"></el-input>
                </el-form-item>
                <el-form-item label="导购员工">
                    <el-select v-model="dym_list_form.shopping_guide" filterable clearable placeholder="请选择导购员工">
                        <el-option v-for="item in guide_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="dymQuery">查询</el-button>
                    <el-button @click="dymExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="dym_list"
                @sort-change="listOrder">
                <el-table-column type="index" label="行号"></el-table-column>
                <el-table-column prop="create_time" width="100" label="支付时间" sortable="custom"></el-table-column>
                <el-table-column prop="order_id" width="110" label="订单编号"></el-table-column>
                <el-table-column prop="pay_platform" label="支付类型"></el-table-column>
                <el-table-column width="130" label="门店">
                    <template slot-scope="scope">
                        {{scope.row.shop_name.length > '14' ? scope.row.shop_name.slice(0, 14) + '...' : scope.row.shop_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="room_area_name" label="包厢区域"></el-table-column>
                <el-table-column prop="room_name" label="包厢号"></el-table-column>
                <el-table-column prop="admin_name" label="操作人"></el-table-column>
                <el-table-column prop="goods_type_name" label="商品类型"></el-table-column>
                <el-table-column width="130" label="商品名称">
                    <template slot-scope="scope">
                        {{scope.row.goods_name.length > '14' ? scope.row.goods_name.slice(0, 14) + '...' : scope.row.goods_name}}
                    </template>
                </el-table-column>
                <el-table-column prop="goods_unit_name" label="单位"></el-table-column>
                <el-table-column prop="actual_pay" label="折后单价"></el-table-column>
                <el-table-column prop="quantity" label="销售数量"></el-table-column>
                <el-table-column prop="actual_pay_total" label="折后总额"></el-table-column>
                <el-table-column prop="deduct_rate" label="商品提成百分比"></el-table-column>
                <el-table-column prop="deduct_amount" label="商品提成金额"></el-table-column>
                <el-table-column prop="shopping_guide_name" label="导购员工" width="100" sortable="custom"></el-table-column>
                <el-table-column prop="deduct_amount_total" label="提成总额"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-6">销售数量合计:</label>
                    <div class="list-total">{{dym_quantity_total}}</div>
                    <label class="list-label-6">销售总额合计:</label>
                    <div class="list-total">{{dym_actual_pay_total}}</div>
                    <label class="list-label-6">提成总额合计:</label>
                    <div class="list-total">{{dym_deduct_amount_total}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="dym_list_page"
                    :total="dym_list_total"
                    @current-change="getDymList">
                </el-pagination>
            </div>
            <!-- 包厢区域弹窗 -->
            <div class="export-wrap" ref="dym_area_alert">
                <el-checkbox :indeterminate="dym_area_sign" v-model="dym_area_all" @change="dymAreaAll">全选</el-checkbox>
                <el-checkbox-group v-model="dym_area_ids" @change="dymAreaChange">
                    <el-checkbox v-for="item in room_area_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 支付类型弹窗 -->
            <div class="export-wrap" ref="dym_pay_alert">
                <el-checkbox :indeterminate="dym_pay_sign" v-model="dym_pay_all" @change="dymPayAll">全选</el-checkbox>
                <el-checkbox-group v-model="dym_pay_ids" @change="dymPayChange">
                    <el-checkbox v-for="item in pay_type_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 商品类型弹窗 -->
            <div class="export-wrap" ref="dym_gtype_alert">
                <el-checkbox :indeterminate="dym_gtype_sign" v-model="dym_gtype_all" @change="dymGtypeAll">全选</el-checkbox>
                <el-checkbox-group v-model="dym_gtype_ids" @change="dymGtypeChange">
                    <el-checkbox v-for="item in goods_type_list" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
                </el-checkbox-group>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="dym_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="dym_export_sign" v-model="dym_export_all" @change="dymExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="dym_export_ids" @change="dymExportChange">
                    <el-checkbox label="create_time">支付时间</el-checkbox>
                    <el-checkbox label="order_id">订单编号</el-checkbox>
                    <el-checkbox label="pay_platform">支付类型</el-checkbox>
                    <el-checkbox label="shop_name">门店</el-checkbox>
                    <el-checkbox label="room_area_name">包厢区域</el-checkbox>
                    <el-checkbox label="room_name">包厢号</el-checkbox>
                    <el-checkbox label="admin_name">操作人</el-checkbox>
                    <el-checkbox label="goods_type_name">商品类型</el-checkbox>
                    <el-checkbox label="goods_name">商品名称</el-checkbox>
                    <el-checkbox label="goods_unit_name">单位</el-checkbox>
                    <el-checkbox label="actual_pay">折后单价</el-checkbox>
                    <el-checkbox label="quantity">销售数量</el-checkbox>
                    <el-checkbox label="actual_pay_total">折后总额</el-checkbox>
                    <el-checkbox label="deduct_rate">商品提成百分比</el-checkbox>
                    <el-checkbox label="deduct_amount">商品提成金额</el-checkbox>
                    <el-checkbox label="shopping_guide_name">导购员工</el-checkbox>
                    <el-checkbox label="deduct_amount_total">提成总额</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="dym_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="dym_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                room_area_list: [],
                room_list: [],
                admin_list: [],
                guide_list: [],
                pay_type_list: [],
                goods_type_list: [],

                dym_list_form: {
                    start_date: '',
                    end_date: '',
                    shop_id: '',
                    room_id: '',
                    room_disabled: false,
                    admin_id: '',
                    goods_name: '',
                    shopping_guide: '',
                    order: '',
                },
                dym_area_sign: false,
				dym_area_all: false,
                dym_area_ids: [],
                dym_area_names: '',
                dym_area_disabled: false,
                dym_pay_sign: false,
				dym_pay_all: false,
                dym_pay_ids: [],
                dym_pay_names: '',
                dym_gtype_sign: false,
				dym_gtype_all: false,
                dym_gtype_ids: [],
                dym_gtype_names: '',
				dym_list: [],
				dym_list_page: 1,
                dym_list_total: 0,
                dym_export_sign: false,
				dym_export_all: false,
                dym_export_ids: [],
                dym_export_list: ['create_time', 'order_id', 'pay_platform', 'shop_name', 'room_area_name', 'room_name', 'admin_name', 'goods_type_name', 'goods_name', 'goods_unit_name', 'actual_pay', 'quantity', 'actual_pay_total', 'deduct_rate', 'deduct_amount', 'shopping_guide_name', 'deduct_amount_total'],
                dym_export_type: '1',
                dym_quantity_total: '',
                dym_actual_pay_total: '',
                dym_deduct_amount_total: '',
            }
        },
        mounted: function() {
            this.dym_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.dym_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.dym_list_form.shop_id = this.shop_list[0].id;
                this.getRoomArea(this.shop_list[0].id);
                this.getRoom(this.shop_list[0].id);
                this.getAdmin(this.shop_list[0].id);
                this.getPayType(this.shop_list[0].id);
                this.getGoodsType();
                this.getGuide(this.shop_list[0].id);
                this.getDymList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.dym_list_form.start_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.dym_list_form.end_date = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.dym_list_form.start_date = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.dym_list_form.end_date = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.dym_list_date).daterangepicker({
                    timePicker: true,
                    timePickerIncrement: 1,
                    timePicker12Hour: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().hour(8).minute(0).toDate(),
                    endDate: moment().add(1, 'day').hour(8).minute(0).toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.dym_list_form.start_date = start.format('YYYY-MM-DD HH:mm');
                    _this.dym_list_form.end_date = end.format('YYYY-MM-DD HH:mm');
                });
            },
            // 获取门店
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        _this.setShopDefaultTime(_this.shop_list[0].id)
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取包厢区域
            getRoomArea: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.dym_area_sign = false;
                    _this.dym_area_all = false;
                    _this.dym_area_ids = [];
                    _this.dym_area_names = '';
                    _this.dym_area_disabled = true;
                } else {
                    _this.dym_area_sign = false;
                    _this.dym_area_all = false;
                    _this.dym_area_ids = [];
                    _this.dym_area_names = '';
                    _this.dym_area_disabled = false;
                    Vue.axios.post('Shop/getRoomArea', {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_area_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 获取包厢号
            getRoom: function(shop_id) {
                const _this = this;

                if(shop_id == '') {
                    _this.dym_list_form.room_id = '';
                    _this.dym_list_form.room_disabled = true;
                } else {
                    _this.dym_list_form.room_id = '';
                    _this.dym_list_form.room_disabled = false;
                    Vue.axios.post('Shop/getAllRoom', {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "shop_id": shop_id
                            }
                        },
                        "comment": ""
                    })
                    .then(res => {
                        if(res.data.response.result_code == "true") {
                            _this.room_list = res.data.response.result;
                        } else {
                            Vue.timeoutfun(res.data.response.result_status, _this);
                            layer.msg(res.data.response.error_msg);
                        }
                    })
                    .catch(err => {
                        layer.msg('出错啦');
                    });
                }
            },
            // 获取操作人
            getAdmin: function(shop_id) {
                const _this = this;

                _this.dym_list_form.admin_id = '';
                Vue.axios.post('User/getList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.admin_list = res.data.response.result.user_info;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取导购员工
            getGuide: function(shop_id) {
                const _this = this;

                _this.dym_list_form.shopping_guide = '';
                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.guide_list = res.data.response.result;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 获取支付类型
            getPayType: function(shop_id) {
                const _this = this;

                _this.dym_pay_sign = false;
                _this.dym_pay_all = false;
                _this.dym_pay_ids = [];
                _this.dym_pay_names = '';
                Vue.axios.post('Order/getAllPayPlatform', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.pay_type_list = [];
                        for(let [key, value] of Object.entries(res.data.response.data)) {
                            _this.pay_type_list.push({id: key, name: value});
                        }
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
            // 商品类型
            getGoodsType: function() {
                const _this = this;

                Vue.axios.post('PublicData/api_getAllGoodsType', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.goods_type_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },



            // 修改门店
            dymShopChange(val) {
                this.setShopDefaultTime(val)
                this.getRoomArea(val);
                this.getRoom(val);
                this.getAdmin(val);
                this.getPayType(val);
                this.getGuide(val);
            },
            // 包厢区域
            dymAreaSelect() {
                const _this = this;
                const c_dym_area_ids = _this.dym_area_ids,
                    c_dym_area_sign = _this.dym_area_sign,
                    c_dym_area_all = _this.dym_area_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择包厢区域', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.dym_area_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.dym_area_ids = c_dym_area_ids;
                        _this.dym_area_sign = c_dym_area_sign;
                        _this.dym_area_all = c_dym_area_all;
                    }
                }, function() {
                    let arr = [];
                    _this.room_area_list.forEach(item => {
                        _this.dym_area_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.dym_area_names = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.dym_area_ids = c_dym_area_ids;
                    _this.dym_area_sign = c_dym_area_sign;
                    _this.dym_area_all = c_dym_area_all;
                });
            },
            dymAreaDel() {
				this.dym_area_sign = false;
                this.dym_area_all = false;
				this.dym_area_ids = [];
            },
            dymAreaAll(val) {
                let ids = [];
				this.room_area_list.forEach(v => {
					ids.push(v.id);
				});
				this.dym_area_ids = val ? ids : [];
				this.dym_area_sign = false;
			},
			dymAreaChange(val) {
				const len = val.length;
				this.dym_area_sign = len > 0 && len < this.room_area_list.length;
				this.dym_area_all = len === this.room_area_list.length;
            },
            // 支付类型
            dymPaySelect() {
                const _this = this;
                const c_dym_pay_ids = _this.dym_pay_ids,
                    c_dym_pay_sign = _this.dym_pay_sign,
                    c_dym_pay_all = _this.dym_pay_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择支付类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.dym_pay_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.dym_pay_ids = c_dym_pay_ids;
                        _this.dym_pay_sign = c_dym_pay_sign;
                        _this.dym_pay_all = c_dym_pay_all;
                    }
                }, function() {
                    let arr = [];
                    _this.pay_type_list.forEach(item => {
                        _this.dym_pay_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.dym_pay_names = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.dym_pay_ids = c_dym_pay_ids;
                    _this.dym_pay_sign = c_dym_pay_sign;
                    _this.dym_pay_all = c_dym_pay_all;
                });
            },
            dymPayDel() {
				this.dym_pay_sign = false;
                this.dym_pay_all = false;
				this.dym_pay_ids = [];
            },
            dymPayAll(val) {
                let ids = [];
				this.pay_type_list.forEach(v => {
					ids.push(v.id);
				});
				this.dym_pay_ids = val ? ids : [];
				this.dym_pay_sign = false;
			},
			dymPayChange(val) {
				const len = val.length;
				this.dym_pay_sign = len > 0 && len < this.pay_type_list.length;
				this.dym_pay_all = len === this.pay_type_list.length;
            },
            // 商品类型
            dymGtypeSelect() {
                const _this = this;
                const c_dym_gtype_ids = _this.dym_gtype_ids,
                    c_dym_gtype_sign = _this.dym_gtype_sign,
                    c_dym_gtype_all = _this.dym_gtype_all;
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['选择商品类型', true],
                    area: ['600px', ''], // 宽高
                    content: $(_this.$refs.dym_gtype_alert),
                    cancel: function() {
                        // 右上角关闭
                        _this.dym_gtype_ids = c_dym_gtype_ids;
                        _this.dym_gtype_sign = c_dym_gtype_sign;
                        _this.dym_gtype_all = c_dym_gtype_all;
                    }
                }, function() {
                    let arr = [];
                    _this.goods_type_list.forEach(item => {
                        _this.dym_gtype_ids.forEach(sub => {
                            if(item.id == sub) {
                                arr.push(item.name);
                            }
                        });
                    });
                    _this.dym_gtype_names = arr.join(',');
                    layer.closeAll();
                }, function() {
                    _this.dym_gtype_ids = c_dym_gtype_ids;
                    _this.dym_gtype_sign = c_dym_gtype_sign;
                    _this.dym_gtype_all = c_dym_gtype_all;
                });
            },
            dymGtypeDel() {
				this.dym_gtype_sign = false;
                this.dym_gtype_all = false;
				this.dym_gtype_ids = [];
            },
            dymGtypeAll(val) {
                let ids = [];
				this.goods_type_list.forEach(v => {
					ids.push(v.id);
				});
				this.dym_gtype_ids = val ? ids : [];
				this.dym_gtype_sign = false;
			},
			dymGtypeChange(val) {
				const len = val.length;
				this.dym_gtype_sign = len > 0 && len < this.goods_type_list.length;
				this.dym_gtype_all = len === this.goods_type_list.length;
            },
            // 列表
            getDymList(page) {
				const _this = this;

                _this.loading = true;
                _this.dym_list_page = page
				Vue.axios.post('FinanceReport2/shoppingGuideOrderList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.dym_list_form.start_date,
                            "end_date": _this.dym_list_form.end_date,
                            "shop_id": _this.dym_list_form.shop_id,
                            "room_area": _this.dym_area_ids,
                            "room_id": _this.dym_list_form.room_id,
                            "admin_id": _this.dym_list_form.admin_id,
                            "pay_platform": _this.dym_pay_ids,
                            "goods_type": _this.dym_gtype_ids,
                            "goods_name": _this.dym_list_form.goods_name,
                            "shopping_guide": _this.dym_list_form.shopping_guide,
                            "order": _this.dym_list_form.order
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.dym_list_total = Number(res.data.response.result.count);
							_this.dym_quantity_total = res.data.response.result.quantity_total;
                            _this.dym_actual_pay_total = res.data.response.result.actual_pay_total;
                            _this.dym_deduct_amount_total = res.data.response.result.deduct_amount_total;
						}
						_this.dym_list = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            // 表格排序
            listOrder(col) {
                console.log(col)
                if (col.prop == 'create_time') {
                    if (col.order == 'ascending') {
                        this.dym_list_form.order = 'timestamp_asc'
                    }else if (col.order == 'descending') {
                        this.dym_list_form.order = 'timestamp_desc'
                    }else {
                        this.dym_list_form.order = ''
                    }
                }else if (col.prop == 'shopping_guide_name') {
                    if (col.order == 'ascending') {
                        this.dym_list_form.order = 'shopping_sort_asc'
                    }else if (col.order == 'descending') {
                        this.dym_list_form.order = 'shopping_sort_desc'
                    }else {
                        this.dym_list_form.order = ''
                    }
                }
                this.getDymList(1)
            },
			// 查询
			dymQuery() {
				this.getDymList(1);
            },
            // 导出
            dymExportAll(val) {
				this.dym_export_ids = val ? this.dym_export_list : [];
				this.dym_export_sign = false;
			},
			dymExportChange(val) {
				const len = val.length;
				this.dym_export_all = len === this.dym_export_list.length;
				this.dym_export_sign = len > 0 && len < this.dym_export_list.length;
			},
            dymExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "FinanceReport2/shoppingGuideOrderListExport"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.dym_export_ids = res.data.response.result.export_fields;
                            _this.dym_export_type = res.data.response.result.export_type;
                        } else {
                            _this.dym_export_ids = _this.dym_export_list;
                            _this.dym_export_type = '1';
                        }
                        _this.dymExportChange(_this.dym_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.dym_list_export)
                }, function() {
                    _this.dymExport();
                });
            },
            dymExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/shoppingGuideOrderListExport?" +
                    "&start_date=" + this.dym_list_form.start_date +
                    "&end_date=" + this.dym_list_form.end_date +
                    "&shop_id=" + this.dym_list_form.shop_id +
                    "&room_area=" + this.dym_area_ids +
                    "&room_id=" + this.dym_list_form.room_id +
                    "&admin_id=" + this.dym_list_form.admin_id +
                    "&pay_platform=" + this.dym_pay_ids +
                    "&goods_type=" + this.dym_gtype_ids +
                    "&goods_name=" + this.dym_list_form.goods_name +
                    "&shopping_guide=" + this.dym_list_form.shopping_guide +
                    "&order=" + this.dym_list_form.order +
                    "&export_fields=" + JSON.stringify(this.dym_export_ids) +
                    "&export_type=" + this.dym_export_type;
                layer.closeAll();
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .export-wrap {
        .el-checkbox {
            width: 100px;
        }
    }
</style>